import React from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Card,
    CardContent,
    withStyles,
} from '@material-ui/core';
import PrintHeader from '../PrintHeader/PrintHeader';

const styles = {
    printPage: {
        breakInside: 'avoid',
        position: 'relative',
    },
};

const ReportPage = ({
    children,
    printHeader,
    classes,
}) => (
    <Grid item xs={12} className={classes.printPage}>
        <Card>
            <CardContent>
                <Grid container justify="flex-end">
                    { printHeader && <PrintHeader title={printHeader} size={32} /> }
                </Grid>
                <Grid container spacing={2}>
                    {children}
                </Grid>
            </CardContent>
        </Card>
    </Grid>
);

ReportPage.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    printHeader: PropTypes.string,
};

ReportPage.defaultProps = {
    printHeader: null,
};

export default withStyles(styles)(ReportPage);
